import React, { useEffect } from 'react'
import styles from './styles.module.scss'
import Button from '../../components/Button'
import { IoIosAdd } from 'react-icons/io'
import { useDispatch, useSelector } from 'react-redux'
import { useState } from 'react'
import Modal from './Modal'
import Table from '../../components/Table'
import { BiTrash } from 'react-icons/bi'
import Confirmation from '../../components/Confirmation/Confirmation'
import { deleteTrackProfile, getTrackProfileCurr, getTrackProfileList, } from '../../actions/directoryBasicEducation'


export default function ProfileTrack() {

  const dispatch = useDispatch()

  const { trackProfileList, trackProfileCurr } = useSelector(state => state.directoryBasicEducation)

  const [selectedItem, setSelectedItem] = useState(null)
  const [confirmation, setConfirmation] = useState(false);

  useEffect(() => {
    dispatch(getTrackProfileList())
  }, [])

  useEffect(() => {
    selectedItem?.trp_id && dispatch(getTrackProfileCurr(selectedItem.trp_id))
  }, [selectedItem])

  const openModal = (data) => () => {
    setSelectedItem(data || {})
  }

  const closeModal = () => setSelectedItem(null)

  const acceptConfirmation = () => {
    closeModal();
    dispatch(deleteTrackProfile(confirmation.id));
    setConfirmation(false);
  };
  const rejectConfirmation = () => {
    setConfirmation(false);
  };

  const renderLi = (data) => {
    const { trp_id, name, isbasic, closed } = data
    return (
      <tr key={trp_id} onClick={openModal(data)}>
        <td>{name}</td>
        <td>{isbasic ? 'Да' : 'Нет'}</td>
        <td>{closed ? 'Да' : 'Нет'}</td>
        <td>
          <button
            type="button"
            className={styles.deleteBtn}
            onClick={(e) => { e.stopPropagation(); setConfirmation({ id: trp_id, name: name }) }}
            title="Удалить запись"
            aria-label="Удалить"
          >
            <BiTrash size={20} />
          </button>
        </td>
      </tr>
    )
  }

  return (
    <div className={styles.wrapper}>
      {confirmation && (
        <Confirmation
          top="30px"
          left="40px"
          title={`Вы уверены, что хотите удалить ${confirmation.name}?`}
          acceptConfirmation={() => acceptConfirmation(confirmation?.name)}
          rejectConfirmation={rejectConfirmation}
        />
      )}
      {selectedItem &&
        <Modal
          closeModal={closeModal}
          data={trackProfileCurr || selectedItem}
          addMode={selectedItem == 'add'}
          
        />
      }

      <header className={styles.header}>
        <h1>Профили обучения</h1>
      </header>

      <main className={styles.content}>
        <Table className={styles.table}>
          <thead>
            <tr>
              <th>Название</th>
              <th style={{ width: '140px' }}>Это Базовый</th>
              <th style={{ width: '110px' }}>Закрыт</th>
              <th style={{ width: '70px' }}>Удалить</th>
            </tr>
          </thead>
          <tbody>
            {trackProfileList?.map(renderLi)}
          </tbody>
        </Table>

        <div className={styles.actions}>
          <Button style={{ padding: '.5rem 1.5rem' }} onClick={openModal('add')}>
            <IoIosAdd size={30} />
            Добавить
          </Button>
          <span className={styles.counter}>Всего записей: {trackProfileList?.length || 0}</span>
        </div>
      </main>
    </div>
  )
}
